// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".slide-fade-enter-active[data-v-22c15036],.slide-fade-leave-active[data-v-22c15036]{transition:all .3s ease-in-out}.slide-fade-enter[data-v-22c15036],.slide-fade-leave-to[data-v-22c15036]{opacity:0}@media screen and (min-width:1024px){.wrp[data-v-22c15036]{left:calc(50% + 130px)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
